var $2adcffe28ea44753$exports = {};
$2adcffe28ea44753$exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};


export {$2adcffe28ea44753$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
